import { useEffect } from "react";
import type { PermissionContextDto } from "@Front/Api/LeCoffreApi/SuperAdmin/RolePermissions/RolePermissions";
import { activeOfficeStore } from "@Front/Stores/ActiveOfficeStore";
import {
	isExcludedNotaryOfficeBootstrapPersona,
	resolveNotaryUserUidForOfficeLoad,
} from "@Front/Hooks/helpers/notaryOfficeAffiliationsLoadEffectHelpers";

/**
 * Ensures activeOfficeStore.availableOffices is loaded for notary sessions.
 * OfficeSelector alone is insufficient: routes without it (e.g. invited received-documents) still need
 * affiliations for GUEST_FOLDERS share resolution (findGuestFoldersActiveShare).
 */
export function useNotaryOfficeAffiliationsLoadEffect(
	permissionContext: PermissionContextDto | null,
	permissionsLoading: boolean,
): void {
	useEffect(() => {
		if (permissionsLoading) {
			return;
		}
		if (isExcludedNotaryOfficeBootstrapPersona(permissionContext)) {
			return;
		}
		const userId = resolveNotaryUserUidForOfficeLoad(permissionContext);
		if (!userId) {
			return;
		}
		void activeOfficeStore.loadUserOffices(userId);
	}, [permissionsLoading, permissionContext]);
}
